import { ruleDefinitionDefaults, defaultValidationTagRule, createValidator } from './TagRulesCommon'


const ruleDefinition =
{
    ...ruleDefinitionDefaults,
    ruleType: "TagProductsOnCreation",
    title: "Auto Tag Products On Creation",
    description: "Automatically tag products when created. This rule will be executed only once - right after a product has been created.",
    example: "Tag all new products with \"To Review\"",
    additional: [],
    legacy: false,
    inProgress: false,
    previewType: "ProductTags",
    tags: ["Products", "Tags"],
    getDefaultRuleState: () => {
        return {
            name: null,
            trigger: "Automatic",
            settings: {
                ruleTypeId: "TagProductsOnCreation",
                tags: [],
            }
        }
    },
    createValidator: (onAsyncError) => {
        return createValidator(
            onAsyncError,
            [defaultValidationTagRule,
                (rule, errors) => { },
            ], null);
    }
};

export default ruleDefinition;